import styled, { css } from 'styled-components';
import { Avatar } from '@bechtel/gds';

export interface AvatarRegularStyledProps {
  hasImageUrl: boolean;
}

export const AvatarRegularStyled = styled(Avatar)<AvatarRegularStyledProps>`
  border-width: 1px !important;
  ${({ theme, hasImageUrl }) => css`
    border-color: ${theme.colors.white};
    background-color: ${hasImageUrl ? theme.colors.white : theme.colors.grey[200]};
  `}
`;
